import React from 'react';
import pharma from '../images/phama.png'
import jhub from '../images/jhub.png'
import dlab from '../images/dlabs.png'
import mety from '../images/Meity.png'
import nasscom from '../images/nasscom_ai_logo.jpeg'
import founder from '../images/founder.png'
import umg from '../images/umg.png'
import aic from '../images/aic.png'

const Collaborators = () => {
    const logos = [
        { id: 1, src: dlab, alt: 'd-labs logo', name: 'D-Labs' },
        { id: 2, src: mety, alt: 'Meity logo', name: 'MeitY' },
        { id: 3, src: umg, alt: 'umg logo', name: 'UMG' },
        { id: 4, src: founder, alt: 'founder logo', name: 'Founder' },
        { id: 5, src: nasscom, alt: 'nasscom logo', name: 'NASSCOM' },
        { id: 6, src: aic, alt: 'aic logo', name: 'AIC' },
        { id: 7, src: jhub, alt: 'jhub logo', name: 'J-Hub' },
        { id: 8, src: pharma, alt: 'pharma logo', name: 'Pharma' }
    ];

    return (
        <div className="relative bg-black text-white overflow-hidden min-h-screen">
            {/* Animated background elements */}
            {/* <div className="absolute inset-0 opacity-10">
                <div className="absolute top-20 left-10 w-96 h-96 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full mix-blend-multiply filter blur-3xl animate-pulse"></div>
                <div className="absolute top-40 right-10 w-80 h-80 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-1000"></div>
                <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-2000"></div>
                <div className="absolute top-1/2 left-20 w-64 h-64 bg-gradient-to-r from-orange-500 to-red-500 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-3000"></div>
            </div> */}

            {/* Floating particles
            <div className="absolute inset-0 overflow-hidden">
                {[...Array(50)].map((_, i) => (
                    <div
                        key={i}
                        className="absolute w-1 h-1 bg-cyan-400 rounded-full opacity-30"
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                            animationDelay: `${Math.random() * 3}s`,
                            animationDuration: `${3 + Math.random() * 2}s`
                        }}
                    ></div>
                ))}
            </div> */}

            <div className="relative z-10 px-4 lg:px-12 py-20 lg:py-32">
                <div className="container mx-auto max-w-7xl">
      <div className="text-center text-3xl sm:text-4xl md:text-5xl font-bold text-left mt-6 ">
                        Welcome to our Collaborative ecosystem
</div>
<div className="text-lg text-[#6FC5F0] text-center tracking-[3px] font-semibold sm:text-xl text-left mt-4">
                        Driving Innovation together for building tomorrow's therapeutics
</div>
<div className="text-base md:text-lg text-left mt-4 opacity-75">
                        We are proud to be associated with global partners. Explore our network of collaborators and witness the transformative impact strategic alliances in shaping the future.
</div>

                    {/* Logos Grid */}
 <div className="bg-white mt-6 rounded-lg py-12 mb-20">
  <div className="flex flex-wrap justify-center gap-8 lg:gap-10">
    {logos.map((logo, index) => (
      <div
        key={logo.id}
        className="group relative w-64"
        style={{
          animationDelay: `${index * 0.1}s`,
        }}
      >
        {/* Glow effect */}
        <div className="absolute inset-0  rounded-3xl blur-xl opacity-0 group-hover:opacity-30 transition-opacity duration-500"></div>

        <div className="relative w-full h-32 md:h-36  rounded-3xl p-6 flex items-center justify-center  ">
          <div className="w-full h-full bg-white rounded-xl flex items-center justify-center group-hover:shadow-2xl transition-all duration-500 transform group-hover:scale-105 group-hover:-translate-y-1">
            <img
              className="h-12 sm:h-16 md:h-20 max-w-full object-contain filter group-hover:brightness-110 transition-all duration-300"
              src={logo.src}
              alt={logo.alt}
            />
          </div>
        </div>
      </div>
    ))}
  </div>
</div>


                    {/* Partnership Stats */}
                    {/* <div className="text-center">
                        <div className="inline-flex items-center justify-center space-x-12 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 rounded-3xl px-12 py-8 border border-gray-700 backdrop-blur-sm shadow-2xl">
                            <div className="text-center group">
                                <div className="text-4xl font-black bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent group-hover:scale-110 transition-transform duration-300">
                                    50+
                                </div>
                                <div className="text-sm text-gray-400 font-medium">Global Partners</div>
                            </div>
                            <div className="w-px h-12 bg-gradient-to-b from-transparent via-gray-600 to-transparent"></div>
                            <div className="text-center group">
                                <div className="text-4xl font-black bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent group-hover:scale-110 transition-transform duration-300">
                                    15+
                                </div>
                                <div className="text-sm text-gray-400 font-medium">Countries</div>
                            </div>
                            <div className="w-px h-12 bg-gradient-to-b from-transparent via-gray-600 to-transparent"></div>
                            <div className="text-center group">
                                <div className="text-4xl font-black bg-gradient-to-r from-emerald-400 to-teal-500 bg-clip-text text-transparent group-hover:scale-110 transition-transform duration-300">
                                    100+
                                </div>
                                <div className="text-sm text-gray-400 font-medium">Joint Projects</div>
                            </div>
                        </div>
                    </div> */}

                    {/* Call to Action */}
                    {/* <div className="text-center mt-16">
                        <div className="inline-block relative">
                            <button className="group relative px-8 py-4 bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-400 hover:to-blue-400 text-white font-bold text-lg rounded-full transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-2xl hover:shadow-cyan-500/50">
                                <span className="relative z-10">Partner With Us</span>
                                <div className="absolute inset-0 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </button>
                        </div>
                    </div> */}
                </div>
            </div>

            <style jsx>{`
                @keyframes float {
                    0%, 100% { transform: translateY(0px); }
                    50% { transform: translateY(-10px); }
                }
                
                .animate-float {
                    animation: float 3s ease-in-out infinite;
                }
                
                .animate-pulse {
                    animation: pulse 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
                }
                
                @keyframes pulse {
                    0%, 100% { opacity: 0.1; }
                    50% { opacity: 0.3; }
                }
                
                .group:hover .transform {
                    transform: translateY(-2px) scale(1.05);
                }
            `}</style>
        </div>
    );
};

export default Collaborators;